module.exports = __webpack_public_path__ + "img/logo.f0c0851c.png";